import { Page } from "./types";

export const getRotate = (page: Page) =>
  page.rotate || Number(page.meta?.Rotate) || 0;
